module.exports = __webpack_public_path__ + "img/wedding-4-min.35816e51.png";